import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const EmptyDescription = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: block;
  padding: ${({ theme }) => `0 ${theme.spacing(3)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
